import { deleteLeasedEquipmentStatus } from "actions/Utilities/LeasedEquipmentStatus";
import { toast } from "components/toastNotification";
import React from "react";
import { useMutation } from "react-query";

export default function useDeleteLeasedEquipmentStatus() {
  const { mutate } = useMutation(
    (ids: number[]) => deleteLeasedEquipmentStatus(ids),
    {
      onSuccess: (res: any) => {
        switch (true) {
          case res == "Success":
            toast.fire("Success", "Status Disabled Successfully", "success");
            break;
          case res.includes("Notification insert Failed"):
            toast.fire(
              "Success ",
              `Status Disabled Successfully, BUT ${res}`,
              "warning"
            );
            break;
          case res == "Operation Failed!":
            toast.fire(
              "Disabling Status failed ",
              `Server Error: ${res}`,
              "error"
            );
            break;
          case res == "Status not found":
            toast.fire("Disabling Status failed ", `Error: ${res}`, "error");
            break;
          default:
            toast.fire("Disabling Status failed", res.Message, "error");
        }
      },
      onError: (error) => {
        toast.fire("Disabling Status failed", `Error: ${error}`, "error");
      },
    }
  );

  return mutate;
}
